import { CycleParameter } from "@/service/models/response/computation/data-responses/cycle-data/cycle-parameter";

export class ParameterVM
{
    public constructor(
        public id: string,
        public population: number,
        public aPriori: number|null,
        public aPosteriori: number|null,
    )
    {
    }

    public get unit(): string
    {
        switch (this.id)
        {
            case "CL": return "l/h";
            case "F": return "%";
            case "Ka": return "h-1";
            case "Q": return "l/h";
            case "V1": return "l";
            case "V2": return "l";

            default: return "???";
        }
    }
}

export class ParametersVM
{
    public parameters = new Map<string, ParameterVM>();

    public constructor(
        populationParams: CycleParameter[],
        aPrioriParams: CycleParameter[] = [],
        aPosterioriParams: CycleParameter[] = [],
    )
    {
        for (const populationParameter of populationParams) {
            this.parameters.set(populationParameter.id, new ParameterVM(
                populationParameter.id,
                populationParameter.value,
                null,
                null
            ));
        }

        this.fillAPrioriParams(aPrioriParams);
        this.fillAPosterioriParams(aPosterioriParams);
    }

    public fillAPrioriParams(aPrioriParams: CycleParameter[]): void
    {
        for (const aPrioriParameter of aPrioriParams) {
            const parameter = this.parameters.get(aPrioriParameter.id);

            if (parameter) {
                parameter.aPriori = aPrioriParameter.value;
            }
        }
    }

    public fillAPosterioriParams(aPosterioriParams: CycleParameter[]): void
    {
        for (const aPosterioriParameter of aPosterioriParams) {
            const parameter = this.parameters.get(aPosterioriParameter.id);

            if (parameter) {
                parameter.aPosteriori = aPosterioriParameter.value;
            }
        }
    }
}
